import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "bi-tmpl-detail__right__cmpt" }
const _hoisted_2 = { class: "bi-tmpl-detail__right__cmpt__title" }
const _hoisted_3 = {
  key: 0,
  class: "bi-tmpl-detail__right__cmpt__tips"
}

import PcModuleTitle from '@V/bi-tmpl/src/components/bi-pc-module/pc-module-title';

import { BaseRadio } from 'xrk-components';
import { BaseCard } from 'xrk-components';
import { useDetailCmpt } from '@V/bi-tmpl/src/hooks';
import { Carousel } from '@/components/base/carousel';

const CHILD_KEY = '101_2';

export default /*#__PURE__*/_defineComponent({
  __name: 'bi-tmpl-detail-101-2',
  setup(__props) {

const TYPE_MAPPING = {
  1: {
    value: 'pc-module-title-1',
    moduleType: 'pc-module-title-1'
  },
  2: {
    value: 'pc-module-title-2',
    moduleType: 'pc-module-title-2'
  },
  3: {
    value: 'pc-module-title-3',
    moduleType: 'pc-module-title-3'
  },
  4: {
    value: 'pc-module-title-4',
    moduleType: 'pc-module-title-4'
  },
  5: {
    value: 'pc-module-title-5',
    moduleType: 'pc-module-title-5'
  },
  6: {
    value: 'pc-module-title-6',
    moduleType: 'pc-module-title-6'
  },
  7: {
    value: 'pc-module-title-7',
    moduleType: 'pc-module-title-7'
  },
  8: {
    value: 'pc-module-title-8',
    moduleType: 'pc-module-title-8'
  }
};

const cmpName = name => {
  return PcModuleTitle.filter(comp => comp.__name === name)[0];
};

const { curItem, onChange, group } = useDetailCmpt({ childKey: CHILD_KEY });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(curItem).title), 1),
      (_unref(curItem).tips)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(curItem).tips), 1))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_unref(Carousel), {
      ref: "carouselRef",
      itemHeight: 200,
      itemWidth: 420 + 56
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(group)(TYPE_MAPPING), (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            style: {"height":"200px"},
            key: index
          }, [
            _createVNode(_unref(BaseCard), { style: {"width":"420px","height":"200px"} }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item, (child) => {
                  return (_openBlock(), _createBlock(_unref(BaseRadio), {
                    class: "bi-tmpl-detail__right__cmpt__radio bi-tmpl-detail__right__cmpt__radio--w",
                    key: child.value,
                    value: child.value,
                    "model-value": _unref(curItem).value,
                    onClick: ($event: any) => (_unref(onChange)(child.value))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(cmpName(child.value)), _mergeProps({
                        style: {"width":"1200px","margin-top":"5px","transform":"scale(0.315)","transform-origin":"center 10%"},
                        ref_for: true
                      }, {
                innerText: '项目总览',
                enInnerText: 'Project Overview',
                index: 1
              }), null, 16))
                    ]),
                    _: 2
                  }, 1032, ["value", "model-value", "onClick"]))
                }), 128))
              ]),
              _: 2
            }, 1024)
          ]))
        }), 128))
      ]),
      _: 1
    }, 512)
  ]))
}
}

})